import { Box, Link, Typography } from '@ace-clublabs/shared-component-library';

interface IDisclaimerComponent {
  clubCode: string;
  isERSSelected?: boolean;
  ersFee?: number;
}

export const DisclaimerComponent = ({ clubCode, isERSSelected, ersFee }: IDisclaimerComponent): JSX.Element => {
  const nonCaliforniaDisclaimer = (
    <Box className="non-ca-disclaimer">
      <Typography variant="b3Regular" sx={{ color: '#404040' }}>
        A non-refundable service fee applies each time you use Roadside Assistance for the first three days of your new
        membership. See{' '}
        <Link href="https://AAA.com/servicefee" target="_blank" sx={{ fontSize: '0.875rem !important' }}>
          AAA.com/servicefee
        </Link>{' '}
        for fee amount.
      </Typography>
    </Box>
  );

  const californiaDisclaimerWithoutERS = (
    <Typography variant="b3Regular" className="ca-ers-not-selected-disclaimer" sx={{ color: '#404040' }}>
      The total paid above reflects membership dues only. An additional ${ersFee} non-refundable service fee will be
      charged for Roadside Assistance for a vehicle disablement that occurred before you joined.
    </Typography>
  );

  const californiaDisclaimerWithERS = (
    <Typography className="ca-ers-selected-disclaimer" variant="b3Regular" sx={{ color: '#404040' }}>
      Please call 1-800-400-4222 and refer to the membership number above to have a service vehicle sent to assist you
      today.
    </Typography>
  );

  if (clubCode !== '004') {
    return nonCaliforniaDisclaimer;
  }

  return isERSSelected ? californiaDisclaimerWithERS : californiaDisclaimerWithoutERS;
};
